import axios from "axios"
import { useEffect, useState } from "react"
import { PlecaMorada } from "../../utilities/PlecaMorada";
import { filtros, filtrosBA } from "../../models/Obras.model";
import BotonesOrdenamiento from "./BotonesOrdenamiento"; 
import { useLocation } from "react-router-dom";
import ResultadosBusqueda from "./ResultadosBusqueda"; 
import Paginacion from "../../components/paginador/paginacion";
import { webApiBusquedaAvanzada, webApiConteoAvanzado, webApiBusqueda, webApiConteoSencillo, webApiFiltrosPredecibles, webApiFiltrosPredeciblesAvanz } from "../../routes/endpoints";
import { catalogoObras } from "../../models/Colecciones.model";
import FiltrosListado from "./FiltrosListado";
import ValoresInputContext from "./context/FiltrosInputContext";
import {ErrorBoundary} from "react-error-boundary";
import ErrorMessageNotifications from "../../components/Errores/ErrorMessageNotifications";
import Loading from "../../utilities/Loading";

export default function Main(props:MainProps){  
    localStorage.setItem("seccion", '')     
    const [listadoObras, setListadoObras] = useState<catalogoObras[]>([])
    const [filtrosPredictivos, setFiltrosPredictivos] = useState([])
    let registrosPorPagina =  10
    const [totalDePaginas, setTotalDePaginas] = useState(0)
    const [pagina, setPagina] = useState(1) 
    const [orden, setOrden] = useState(1) 
    const [isAnioAsc, setIsAnioAsc] = useState(true) 
    const [tipo, setTipo] = useState(1)    
    const [filtros, setFiltros] = useState<filtros>({titulo:'',autor:'',palabraClave:'',ISBN:'',coleccion:''}) 
    const query = new URLSearchParams(useLocation().search) 
    const [peticion, setPeticion] = useState(false)
    const [load, setLoad] = useState(true)
    const [coincidencias, setCoincidencias] = useState(0)
    useEffect(()=>{
        const keysToRemove = ["fil_titulo", "fil_autor", "fil_palabraClave"]
        for (const key of keysToRemove) localStorage.removeItem(key)         
    },[])
    useEffect(()=>{ setPagina(1) },[props.filtrosBA])
    useEffect(()=>{         
        setLoad(true)  
        let palabra = (query.get('q'))?query.get('q')!:''  
        const requestConteo = (props.filtrosBA===undefined)?axios.post(webApiConteoSencillo, {palabra,filtros}):axios.post(webApiConteoAvanzado, {palabra,filtros, filtrosBA:props.filtrosBA})
        const requestEncontrados = (props.filtrosBA===undefined)?axios.post(webApiBusqueda, {palabra,pagina,orden,registrosPorPagina, filtros,isAnioAsc}):axios.post(webApiBusquedaAvanzada, {palabra,pagina,orden,registrosPorPagina, filtros, filtrosBA:props.filtrosBA,isAnioAsc})
        axios.all([requestConteo, requestEncontrados]).then(axios.spread((...responses)=>{  
            setCoincidencias((responses[0].data)[0].total_registros)
            setTotalDePaginas(Math.ceil(((responses[0].data)[0].total_registros)/registrosPorPagina))
            setListadoObras(responses[1].data)             
            setPeticion(true)
        })).catch(errors => console.warn(errors)).finally( ()=>setLoad(false) )
    },[pagina,orden, filtros, registrosPorPagina, tipo, props.filtrosBA,isAnioAsc])
    
    useEffect(()=>{
        let palabra = (query.get('q'))?query.get('q')!:'' 
        const requestFiltros = (props.filtrosBA===undefined)?axios.post(webApiFiltrosPredecibles, {palabra,filtros}):axios.post(webApiFiltrosPredeciblesAvanz, {palabra,filtros, filtrosBA:props.filtrosBA})
        axios.all([requestFiltros]).then(axios.spread((...responses)=>{  
            setFiltrosPredictivos(responses[0].data)                                             
        })).catch(err => console.warn(err))                 
    },[filtros,props.filtrosBA]) 
    if(load){
        return(   
            <>
            <div className="container-fluid mt-5 banner_sticky"> 
                <div className="row">
                    <div className="col-md-10 col-xs-12 back_blue px-5">
                        <h5 className="text_white mb-0 py-3 text-center">Resultados de la búsqueda</h5>
                    </div>
                </div>
            </div>
            <Loading/>
            </>   
        ); 
    }else{    
    return(   
        <>
        <div className="container-fluid mt-5 banner_sticky"> 
            <div className="row">
                <div className="col-md-8 col-xs-12 back_blue px-5 text-center">
                    <h5 className="text_white mb-0 py-3 text-center">Resultados de la búsqueda</h5>
                </div>
                <div className="col-md-2 col-xs-12 back_blue px-5">
                    <h5 className="text_white mb-0 py-3 text-center">{(coincidencias) } coincidencias</h5>
                </div>
            </div>
            <div className="row mb-5">
                <ValoresInputContext.Provider value={filtros}>
                    <div className="col-md-10 col-xs-12">
                        {(tipo===2) && <FiltrosListado getFiltros={filtro=> {setFiltros(filtro); setPagina(1) }} predictivos={filtrosPredictivos}/> }
                        <ErrorBoundary FallbackComponent={ErrorMessageNotifications}>  
                            <ResultadosBusqueda resultados={listadoObras} tipo={tipo} peticion={peticion} pag={pagina}/>     
                        </ErrorBoundary>    
                        
                        <Paginacion 
                            cantidadTotalDePaginas={totalDePaginas} 
                            paginaActual={pagina} 
                            onChange={nuevaPagina=>setPagina(nuevaPagina)} 
                            registrosPorPagina={registrosPorPagina} 
                        /> 
                    </div>
                    <div className="col-md-2 col-xs-12 mt-2">
                        <BotonesOrdenamiento 
                            ordenamiento={nuevoOrden=> { setOrden(nuevoOrden); setPagina(1); setIsAnioAsc(!isAnioAsc) }} 
                            getFiltros={filtro=> {setFiltros(filtro); setPagina(1) }} 
                            asignaVisualizacion={ nuevoTipo =>{ setTipo(nuevoTipo); setPagina(1)} }
                            listaOPanel = {tipo}
                            predictivos={filtrosPredictivos}
                        />
                    </div>
                </ValoresInputContext.Provider>
            </div>
            <PlecaMorada/>
        </div>
        </>
    )
    }
}

interface MainProps{
    filtrosBA?:filtrosBA,
    paginaBA?:number

}